var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(!_vm.nofoot.includes(_vm.$route.name))?_c('footer-e'):_vm._e(),_c('dialogLogin',{attrs:{"showLogin":_vm.showLogin},on:{"close":_vm.showColse}}),_c('o-sidebar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }